import { render } from "./Button.vue?vue&type=template&id=68d1ab54"
import script from "./Button.vue?vue&type=script&lang=ts"
export * from "./Button.vue?vue&type=script&lang=ts"

import "./Button.vue?vue&type=style&index=0&id=68d1ab54&lang=scss"
script.render = render

export default script